import { MfaRequest } from '@playq/octopus2-auth';
import { GenericFailure } from '@playq/services-shared';

import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';
import { snackbarService } from '/common/snackbarService';

import { userProfileKey } from './useUpdateProfile';

const requestResetMfaCodesKey = userProfileKey.concat('requestCodesReset');

export const useRequestResetMFACodes = (
  options?: UseMutationOptionsExtended<MfaRequest | undefined, GenericFailure | Error>
) =>
  useEitherMutation(() => services2.userProfileService.requestCodesReset(), {
    mutationKey: requestResetMfaCodesKey,
    onError: (err) => {
      snackbarService.error('Could not reset recovery codes. Message: ', err.message);
    },
    ...options,
  });
